import { computed, ref, watch } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'

export default ({
  name: 'EmailConfirmation',
  setup(_, context) {
    const { $store } = context.root
    const isEnabledTimerEmail = computed(() => $store.state.auth.isEnabledTimerEmail)
    const timer = ref(null)
    const currentTime = ref(60)

    const user = computed(() => $store.state.auth.user)

    const { makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('auth/resendConfirmationEmail', user.value),
      successMessage: `Письмо отправлено на ${user.value.email}`,
    })
    const startTimer = () => {
      $store.dispatch('auth/setTimerState', true)
      timer.value = setInterval(() => {
        currentTime.value -= 1
      }, 1000)
    }
    const stopTimer = () => {
      $store.dispatch('auth/setTimerState', false)
      clearInterval(timer.value)
      currentTime.value = 60
    }

    const resend = () => {
      startTimer()
      makeRequest()
    }
    watch(() => currentTime.value, (val) => {
      if (val === 0) {
        stopTimer()
      }
    })
    return {
      user,
      isEnabledTimerEmail,
      currentTime,
      resend,
    }
  },
})
